import * as z from 'zod';

export type ServicePlanItemFormSchemaValues = z.infer<typeof servicePlanItemFormSchema>;
export const servicePlanItemFormSchema = z.object({
    name: z.string().nonempty(),
    code: z.string().nonempty(),
    is_required: z.boolean(),
    /** Null for a fixed fee. Required by the API when a pricing policy uses `per_unit`. */
    billable_metric: z.string().optional().nullable(),
    external_item_id: z.string().max(64).optional().nullable(),
    service_plan: z.string().nonempty(),
    starting_quantity: z.int().optional().nullable(),
    unit: z.string().optional().nullable(),
});
